import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ClientService } from '../shared/services/client.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent {

  constructor(private router: Router, private clientService: ClientService) {}
  
  goBackHome() {
    const currentClient = this.clientService.getCurrentClient();
    if(currentClient) {
      this.router.navigate([currentClient, 'teacher', 'dashboard']);
    } else {
      this.router.navigate(['/']);
    }
  }
}